export default __webpack_public_path__ + "static/media/menuBg.2705387a.png";